/* Vanillas of the World — cart-count bubble sync.
   Browsers cache the entire prior page in bfcache (back-forward cache). When
   users hit Back after adding to cart, the bubble shows the old count. This
   script fetches /cart.js on `pageshow` (fires for both fresh loads and
   bfcache restores) and rewrites the bubble. It also updates on Shopify's
   `cart:refresh` event that some apps emit.
*/
(function () {
  'use strict';

  function updateBubble(itemCount) {
    var cartLink = document.getElementById('cart-icon-bubble');
    if (!cartLink) return;
    var bubble = cartLink.querySelector('.cart-count-bubble');
    if (itemCount > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML =
          '<span aria-hidden="true">' +
          (itemCount < 100 ? itemCount : '99+') +
          '</span><span class="visually-hidden">' +
          itemCount +
          ' items</span>';
        cartLink.appendChild(bubble);
      } else {
        var span = bubble.querySelector('[aria-hidden="true"]');
        if (span) span.textContent = itemCount < 100 ? String(itemCount) : '99+';
      }
    } else if (bubble) {
      bubble.remove();
    }
  }

  function refreshCart() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') updateBubble(cart.item_count);
      })
      .catch(function () {});
  }

  // Fire on initial load AND on bfcache restore (back button).
  window.addEventListener('pageshow', refreshCart);
  document.addEventListener('cart:refresh', refreshCart);
})();
